export default __webpack_public_path__ + "img/ami_wave_pic.677c775f.jpg";